import { render, staticRenderFns } from "./ModalReport.vue?vue&type=template&id=773901e0&scoped=true"
import script from "./ModalReport.ts?vue&type=script&lang=ts&external"
export * from "./ModalReport.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773901e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773901e0')) {
      api.createRecord('773901e0', component.options)
    } else {
      api.reload('773901e0', component.options)
    }
    module.hot.accept("./ModalReport.vue?vue&type=template&id=773901e0&scoped=true", function () {
      api.rerender('773901e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/report_management/components/modalReport/ModalReport.vue"
export default component.exports